export default "__VITE_ASSET__BaJZd3A4__"